<template>
  <div class="main">
    <GoBack :name="`信用明细`" :type="2" :path="`/mobile/my`"></GoBack>

    <div class="credit-box" ref="scrollContainer" @scroll="handleScroll">
      <div class="credit-item" v-for="(item, index) in tableData2" :key="index">
        <div class="left">
          <div class="name">{{ item.description }}</div>
          <div class="title">{{ item.dateline | dateFrom }}</div>
        </div>
        <div class="right">
          {{ item.typeId === 1 ? "+" : "-" }}{{ item.quantity }}
        </div>
      </div>
      <div class="flag" v-if="!flag && tableData2.length !== 0">
        触底加载更多
      </div>
      <div class="flag" v-if="flag && tableData2.length !== 0">已经到底了~</div>

      <el-empty
        v-if="tableData2.length === 0"
        description="暂无数据"
      ></el-empty>
    </div>
  </div>
</template>
<script>
import GoBack from "@/components/goBack";
import { getCredits } from "@/api/mobile";
export default {
  filters: {
    dateFrom(data) {
      const date = new Date(data);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份是从0开始的
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
  },
  data() {
    return {
      value: null,
      menuTop: 86,
      options: [
        {
          value: 1,
          label: "已完成",
        },
        {
          value: 2,
          label: "未完成",
        },
        {
          value: 3,
          label: "其它",
        },
      ],
      options2: [
        {
          value: 1,
          label: "已审核",
        },
        {
          value: 2,
          label: "待审核",
        },
        {
          value: 3,
          label: "其它",
        },
      ],
      tableData: [],

      flag: false,
      page2: 1,
      size2: 10,
      tableData2: [],
    };
  },
  components: { GoBack },
  methods: {
    getCredits2(type) {
      if (type) {
        this.page2 = type;
        this.flag = false;
        this.tableData2 = [];
      }

      if (this.flag) {
        return;
      }
      getCredits({
        page: this.page2,
        size: this.size2,
      }).then((res) => {
        if (res.code === 200) {
          if (res.data.list.length > 0) {
            this.tableData2 = this.tableData2.concat(res.data.list);
            if (res.data.list.length === 10) {
              this.page2++;
            } else {
              this.flag = true;
            }
          }
        }
      });
    },
    handleScroll(e) {
      const container = this.$refs.scrollContainer;
      console.log(
        container.scrollTop + container.clientHeight,
        container.scrollHeight
      );
      // 检查是否接近底部
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight - 1
      ) {
        // 触底逻辑，例如加载更多数据
        console.log("触底");
        this.getCredits2();
      }
    },
  },
  created() {
    this.getCredits2();
  },
};
</script>
<style lang="scss" scoped>
.flag {
  text-align: center;
  color: #999;
  font-size: 14px;
}
.main {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background-color: #f8f8fa;
  .credit-box {
    height: calc(100vh - 80px);
    overflow: auto;
  }
  .credit-item {
    width: calc(100% - 30px);
    height: 79px;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    margin-left: 15px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
      display: flex;
      flex-direction: column;
      margin-left: 10px;
      .name {
        color: #232323;
        font-size: 14px;
        font-weight: bolder;
      }
      .title {
        font-size: 12px;
        margin-top: 9px;
        color: #999999;
      }
    }
    .right {
      color: #ffa200;
      margin-right: 11px;
      font-size: 16px;
      font-weight: bolder;
    }
  }
}
</style>